import { render, staticRenderFns } from "./Diagram.vue?vue&type=template&id=6a28d2cc&"
import script from "./Diagram.vue?vue&type=script&lang=ts&"
export * from "./Diagram.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports